import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {RegistryService} from "../../../services/registry.service";
import {AuthService} from "../../../../../services/auth.service";
import {CheckoutCustomerDetailsComponent} from "../checkout-customer-details/checkout-customer-details.component";
import {CartWidgetComponent} from "../cart-widget/cart-widget.component";
import {ShippingMethodsComponent} from "../shipping-methods/shipping-methods.component";
import {PaymentMethodsComponent} from "../payment-methods/payment-methods.component";
import {CheckoutShippingAddressComponent} from "../checkout-shipping-address/checkout-shipping-address.component";
import {CartService} from "../../../services/cart.service";
import {GoogleAnalyticsService} from "../../../services/google-analytics.service";

@Component({
    selector: 'app-checkout-wizard',
    templateUrl: './checkout-wizard.component.html',
    styleUrls: ['./checkout-wizard.component.css']
})
export class CheckoutWizardComponent implements OnInit, OnDestroy {

    @ViewChild('customerDetailsComp') customerDetailsComp: CheckoutCustomerDetailsComponent;
    @ViewChild('cartWidgetComp') cartWidgetComp: CartWidgetComponent;
    @ViewChild('shippingAddressesComp') shippingAddressesComp: CheckoutShippingAddressComponent;
    @ViewChild('shippingMethodsComp') shippingMethodsComp: ShippingMethodsComponent;
    @ViewChild('paymentMethodsComponent') paymentMethodsComponent: PaymentMethodsComponent;


    userLoggedOutEvent;

    constructor(public registry: RegistryService,
                private authService: AuthService,
                private googleService: GoogleAnalyticsService,
                private cartService: CartService
    ) {

        this.userLoggedOutEvent = this.authService.UserLoggedOutEvent$.subscribe(result => {

            this.customerDetailsComp.reset();
            this.cartWidgetComp.reset();
            this.shippingAddressesComp.reset();
            this.shippingMethodsComp.reset();
            this.paymentMethodsComponent.reset();

        });

    }

    ngOnInit(): void {

        this.googleService.eventEmitter("checkout_started", 'checkout', 'checkout_started','');

    }



    itemRemoved() {

    }

    ngOnDestroy(): void {

        this.userLoggedOutEvent.unsubscribe();
    }

}
